import { useState } from "react";
import toggle from "./toggle";
import MenuItem from "./menu-item";

function WhyRollinsMenu(props) {
  const [isWhyRollinsMenu, toggleWhyRollinsMenu] = useState(false);
  const toggleFunction = () => {
    toggle(toggleWhyRollinsMenu, !isWhyRollinsMenu);
  };

  return (
    <div
      className={`block visible hidden lg:block absolute w-full inset-x bg-white z-10 py-8 border-b-4 border-yellow-500 ${
        props.cssClass || ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4">
        <ul className="flex flex-wrap -mx-2">
          <li className="w-full md:w-4/12 px-2">
            <ul className="my-2">
              <li className="py-1">
                <MenuItem
                  linkClass="p-2"
                  linkKey="Why Rollins"
                  linkUrl="/why-rollins/"
                  linkText="Why Rollins"
                  toggleFunction={toggleFunction}
                  linkDescription="Experience Rollins Gateway, our signature approach to preparing students for meaningful lives and productive careers."
                />
              </li>
              <li className="py-1">
                <MenuItem
                  linkClass="p-2"
                  linkKey="RollinsLife"
                  linkUrl="/why-rollins/future-proof-foundation"
                  linkText="A Future-Proof Foundation"
                  toggleFunction={toggleFunction}
                  linkDescription="Explore our innovative curriculum, which gives you the tools and knowledge to stay ahead of the curve."
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-2">
            <ul className="my-2">
              <li className="py-1">
                <MenuItem
                  linkClass="p-2"
                  linkKey="Liberal Arts"
                  linkUrl="/why-rollins/liberal-arts-in-action"
                  linkText="Liberal Arts in Action"
                  toggleFunction={toggleFunction}
                  linkDescription="Put your newfound know-how to work in the world through an array of immersive experiences."
                />
              </li>
              <li className="py-1">
                <MenuItem
                  linkClass="p-2"
                  linkKey="Mentorship"
                  linkUrl="/why-rollins/mentorship-mastered"
                  linkText="Mentorship, Mastered"
                  toggleFunction={toggleFunction}
                  linkDescription="At Rollins, you have the freedom to pursue your unique interests and goals, but you’ll never walk alone. Find out why mentorship matters most."
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-2">
            <ul className="my-2">
              <li className="py-1">
                <MenuItem
                  linkClass="p-2"
                  linkKey="Rollins Results"
                  linkUrl="/why-rollins/rollins-ready"
                  linkText="Rollins Results"
                  toggleFunction={toggleFunction}
                  linkDescription="Start planning your Rollins Gateway by exploring the journeys of the changemaking Tars who’ve gone before you."
                />
              </li>
              <li className="py-1">
                <MenuItem
                  linkClass="p-2"
                  linkKey="Finish in Four"
                  linkUrl="/why-rollins/finish-in-four-graduation-guarantee"
                  linkText="Finish in Four"
                  toggleFunction={toggleFunction}
                  linkDescription="Our four-year graduation promise guarantees everything you need to complete your degree on time."
                />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default WhyRollinsMenu;
